import React from 'react';
import returnNull from '../../atoms/null';

export const Profile = ({ config = {}, isDarkModeEnabled = false }) => {
  const UserProfileComponent = window?.QT_COMPONENTS?.UserProfilePage || returnNull;
  return <UserProfileComponent profileConfig={config} isDarkModeEnabled={isDarkModeEnabled} invokedFrom="PB" />;
};
